import React from 'react';

const TablePayment = (): JSX.Element => {
  return (
    <div>
      <h1>TablePayment</h1>
    </div>
  );
};

export default TablePayment;
